/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { SectionDropdown } from "./SectionDropdown";

export const SectionColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { sections, sectionValues, setSectionValues }
) => (
  <SectionDropdown
    id={row.id}
    sections={sections}
    sectionValues={sectionValues}
    setSectionValues={setSectionValues}
  />
);